import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-detail-view',
  templateUrl: './detail-view.component.html',
  styleUrls: ['./detail-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DetailViewComponent {
  @Input() data: any;
  @Input() title: string = '';
  @Output() closeClicked: EventEmitter<void> = new EventEmitter<void>();
  @Input() headerTemplate: TemplateRef<any> | null = null;

  onCloseButtonClicked() {
    this.closeClicked.emit();
  }
}
